interface Props {
  percent: number;
  /** E2E `data-testid` root; the fill is `${testId}-fill`. */
  testId?: string;
}

export function CoverageBar({ percent, testId = 'coverage-bar' }: Props) {
  const clamped = Math.max(0, Math.min(100, percent));
  const impact = clamped < 50 ? 'low' : 'high';
  return (
    <div data-testid={testId} className="bg-primary/10 h-3 flex-1 overflow-hidden rounded-full">
      <div
        data-testid={`${testId}-fill`}
        className={
          impact === 'high'
            ? 'bg-primary h-full rounded-full'
            : 'bg-stage-active h-full rounded-full'
        }
        style={{ width: `${String(clamped)}%` }}
      />
    </div>
  );
}
